import { environment } from '../../environments/environment';

export type SsoLogoutOrigin = 'lab' | 'hr' | 'gateway' | 'insurance';

function nestChain(urls: string[]): string {
  if (urls.length === 0) return '';
  if (urls.length === 1) return urls[0];
  return `${urls[0]}?next=${encodeURIComponent(nestChain(urls.slice(1)))}`;
}

function compactUrls(...urls: (string | undefined)[]): string[] {
  return urls.filter((u): u is string => !!u?.trim());
}

/**
 * بعد إنهاء الجلسة على خادم المصادقة، يبدأ المتصفح زيارة بقية الأنظمة لمسح التخزين المحلي.
 */
export function buildLogoutCascadeUrlFrom(origin: SsoLogoutOrigin): string {
  const s = environment.ssoLogout;
  if (!s?.enabled) return '';
  const lab = s.labLogoutUrl;
  const hr = s.hrLogoutUrl;
  const ins = (s as { insuranceLogoutUrl?: string }).insuranceLogoutUrl;
  const gw = s.gatewayLogoutUrl;
  const login = s.gatewayLoginUrl;
  let seq: string[];
  if (origin === 'lab') seq = compactUrls(hr, ins, gw, login);
  else if (origin === 'hr') seq = compactUrls(lab, ins, gw, login);
  else if (origin === 'insurance') seq = compactUrls(lab, hr, gw, login);
  else seq = compactUrls(lab, hr, ins, login);
  return nestChain(seq);
}
